/* ****************************************************************************
Name:			  Cerfificate upload
**
** Desc:         This code is to manager supplier certificates
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  10/26/2020  Vasu Pabbaraju.           Added force update s3 file upload file/delete file - Q360-384
                                          Line Numbers: 82,217, 265, 311
**  11/24/2020  Vasu Pabbaraju.           Changed file upload chunksize to 150000000

******************************************************************************/ 


import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { withRouter } from "react-router-dom";
import axios from 'axios';
import { FileUploader} from 'devextreme-react/file-uploader';
import DataTable from 'react-data-table-component'
import {
   Row, Col, CardBody, CardHeader,Modal,ModalBody,
  Card
} from 'reactstrap';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import gql from 'graphql-tag';
import { useLazyQuery} from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as FileSaver from 'file-saver';


const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};


const FileUploaderObjGeneric = (options) => {
  console.log(options)
  const [files, setFiles] = useState(null);
  const [chunksObject, setChunks] = useState([]);
  const [percent, setPercent] = useState(0);
  const [certFiles, setCertFiles] = useState(null);
  const [certificates, setCertificates] = useState(null);
  const [showDeleteFile, setShowDeleteFile] = useState(false);
  const [SelectedFile, setSelectedFile] = useState(null);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const [fileUploadErrorMessage, setFileUploadErrorMessage] = useState(null);
  const [refresh,setRefresh] = useState(null);
  const [lots,setLots] = useState(null);
  const [lotsloading, setlotsloading] = useState(false);
  const [showLoading, setShowLoading] = useState(null);


  const onUploadProgress = (e) => {
    //console.log(e)  

    const chunk = {
      segmentSize: e.segmentSize,
      bytesLoaded: e.bytesLoaded,
      bytesTotal: e.bytesTotal,
      fileGUID: options.reportFileGUID
    };

    setChunks([...chunksObject, chunk]);
    let t_percent = percent;
    t_percent = ((e.bytesLoaded / e.bytesTotal) * 100).toFixed(0);

    if (e.bytesTotal == e.bytesLoaded) {
      setPercent(100);
    }
    setPercent(t_percent);
  }

  const onUploadStarted = () => {
    setChunks([]);
  }

  const onUploadError = (data) => {
    if (data.error.response) {
      setShowFileUploadError(true);
      setFileUploadErrorMessage(JSON.parse(data.error.response)['message']);
    }
    
  }

  const updateTable = (data) => {
    setRefresh(new Date());
    GetFiles();
   
  }
  const getValueInKb = (value) => {
    return `${(value / 1024).toFixed(0)}kb`;
  }

  useEffect(() => { 
    if (!files) {
      GetFiles();
    }
    
  });

  const columns = [
    {
      name: "File Name",
      cell: (row) => (
        <div style={{ maxWidth: "80%", whiteSpace: "pre-wrap" }}>
          {row.Key}{" "}
        </div>
      ),
      selector: "Key",
      sortable: true,
      grow: 3,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    
    {
      name: "Uploaded By",
      selector: "UploadedBy",
      sortable: true,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
      
    {
      name: "Uploaded On",
      selector: "LastModified",
      sortable: true,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    } ,{
      name: "",

      cell: (row) => (
        <i
       
          onClick={() => {
            setSelectedFile(row);
            setShowDeleteFile(true);
          }}
          class="fas fa-trash-alt"
        ></i>
      ),
    },
  ];

  const fileConfig = {
    multiple: false,
    uploadMode: 'instantly',
    accept: '.pdf',
    selectedFiles: []
  };

  let uploadURL = window.location.origin + '/file_uploader';
  if (window.location.hostname == 'localhost') {
    uploadURL = 'http://' + window.location.hostname + ':5000/file_uploader';
  }
  const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;


  if (options['header']) {
    options['header']['node']['key'] = options['data']['node']['NotifNum'];
    options['header']['node']['authVendorID'] = localStorage.getItem('loggedInVendor');
    options['header']['node']['authorization'] = token;
    options['header']['node']['userid'] =  JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase();
    options['header']['node']['mode'] =  options.mode;
  }

  const GetFiles = () => {

    let url = window.location.origin + '/get_s3_folder_files';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/get_s3_folder_files';
    }
    const formData = new FormData();
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'authorization': token || null,
        'authVendorID': JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase()

      }
    };

    fetch(url, {
      method: 'POST',
       headers: {
        'Content-Type': 'application/json',
        'responseType': 'application/octet-stream',
        'authorization': token || null,
        'authVendorID': localStorage.getItem('loggedInVendor'),
        'folder': localStorage.getItem('loggedInVendor') + "/" + options.mode +"/" + options.header.node.NotifNum
      }
    }).then(function (response) {
      if (response.ok) {
        return response;
      }
      throw new Error('Network response was not ok.');
    }).then(res => res.json())
      .then(data => {
    
        setFiles(data.Contents);
      }).catch(err => {
        console.log(err);
       // setShowLoader(false);
        alert('Oooops!, problem downloading template');

      }
      );

 
  
  }

  //Delete loaded certificates function
  //This functions makes an API call to delete the file from DB as well as S3 Bucket
  const deleteFile = () => {
    // setShowLoading(true);
    if (SelectedFile) {
      const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
      let url = window.location.origin + '/file_delete';
      if (window.location.hostname == 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/file_delete';
      }

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ fileData: SelectedFile }),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(res => {
        setShowDeleteFile(false);
        updateTable();
           }).catch(err => alert('Unable to download data'));

    }
  }


  return (
    <>
      <div className="widget-container">
        <Row>
          <Col lg={8}>
            <Card>
              <CardHeader>Certficates Uploaded</CardHeader>
              <CardBody>
                {files ? (
                  <DataTable
                    title="Google Sheets-esqe"
                    columns={columns}
                    data={files}
                    highlightOnHover
                    pointerOnHover
                    pagination
                  />
                ) : null}
              </CardBody>
            </Card>
          </Col>
       
            <Col lg={4}>
              <Card>
                <CardHeader>Upload Certficates</CardHeader>
                <CardBody>
                  <div className="main-block">
                    <div className="file-uploader-block">
                      <FileUploader
                        id="files"
                        elementAttr={options.header}
                        uploadHeaders={options.header.node}
                        multiple={fileConfig.multiple}
                        accept={fileConfig.accept}
                        uploadMode={fileConfig.uploadMode}
                        name="files"
                        uploadUrl={uploadURL}
                        chunkSize={150000000}
                        onUploaded={(data) => updateTable(data)}
                        onUploadError={onUploadError}
                        onUploadStarted={onUploadStarted}
                        onProgress={onUploadProgress}
                      />

                      <span className="note">
                        {"Allowed file extensions: "}
                        <span>.pdf</span>
                        {"."}
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
       
        </Row>
    </div>

    <SweetAlert
          show={showDeleteFile}
          warning
          showCancel
          confirmBtnText="Yes, delete it!"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={() => deleteFile()}
          onCancel={() => setShowDeleteFile(false)}
          focusCancelBtn
        >
          You will not be able to recover this file!
        </SweetAlert>
    </>
  );

}

export default (withRouter(FileUploaderObjGeneric))
